import { uploadToS3V2 } from '../db/aws_s3_utils.js';
import config from '../utils/conf.js';

/**
 * Sets up the onpopstate event handler to prompt the user about leaving,
 * clears local storage if confirmed, and uploads results to S3.
 *
 * @param {Object} userData - User-specific data for constructing the file path.
 * @param {Function} navigate - Navigation function to redirect after confirmation.
 * @param {Object} location - Location object to maintain path if the user cancels.
 */
export const handleOnPopState = (userData, navigate, location) => {
  window.onpopstate = async () => {
    if (window.confirm("If you leave now you will have to restart the test. Are you sure you want to leave?")) {
      const results = JSON.parse(localStorage.getItem("results")) || {};
      const params = {
        baseUrl: config.COGNET_DB_API_URL,
        patientId: userData.UUID,
        dbName: userData.origin,
        testType: userData.examType,
        attempt: userData.attemptNumber,
        screenId: "popstate",
        extension: "JSON",
        contentType: "application/json",
        fileBuffer: new Blob([JSON.stringify(results)], { type: "application/json" })
      };

      try {
        await uploadToS3V2(params);
        // localStorage.clear();
        // navigate("/");
      } catch (error) {
        console.error("Error uploading JSON to S3:", error);
      }
    } else {
      navigate(location.pathname);
    }
  };
};
